import { createContext, useContext } from 'react';

export const PaymentMonthContext = createContext<string | undefined>(undefined);
export const usePaymentMonth = () => useContext(PaymentMonthContext);

export const currentPaymentMonth = (date = new Date()) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

export const shiftPaymentMonth = (month: string, direction: -1 | 1) => {
  const [year, number] = month.split('-').map(Number);
  const index = Math.max(
    1900 * 12,
    Math.min(9998 * 12 + 11, year * 12 + number - 1 + direction)
  );
  return `${Math.floor(index / 12)}-${String((index % 12) + 1).padStart(2, '0')}`;
};
